import { colors, space } from "shared/styles/constants";
import styled from "styled-components";
import { InputFieldWrapper, StyledInputField } from "../styles";

interface ColorPreviewProps {
  color?: string | null;
}

export const ColorPreview = styled.div<ColorPreviewProps>`
  position: absolute;
  left: ${space.m};

  width: ${space.l};
  height: ${space.l};

  border-radius: 50%;
  border: 1px solid ${colors.grey5};

  background-color: ${({ color }) => color || "none"};
`;

export const ColorFieldWrapper = styled(InputFieldWrapper)`
  position: relative;
`;

export const StyledColorField = styled(StyledInputField)`
  padding-left: ${space.xxl};
`;
